"use client";

import React from 'react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
export default function StartYourForge() {
  return <section id="start-your-forge" className="dark bg-background text-foreground relative w-full min-h-[600px] flex items-center justify-center overflow-hidden py-24">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,var(--background)_70%)] opacity-40 pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* Main Heading */}
          <h2 className="text-5xl md:text-7xl lg:text-9xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60 drop-shadow-[0_0_30px_rgba(255,255,255,0.2)]">BEREIT GELD ZU SPAREN?</h2>

          {/* CTA Button */}
          <div className="flex justify-center">
            <Link to="/ContactPage">
              <Button size="lg" className="
                  text-xl md:text-2xl px-10 py-8 h-auto rounded-full font-bold tracking-wide
                  bg-primary text-primary-foreground
                  shadow-[0_0_50px_-10px_var(--color-primary)]
                  hover:shadow-[0_0_80px_-10px_var(--color-primary)]
                  hover:scale-105
                  active:scale-95 active:shadow-none
                  transition-all duration-300 ease-out
                  border-2 border-primary/50
                ">Kontaktiere uns<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-3 size-6 md:size-8" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/StartYourForge.tsx|sig:gm2tup" data-ast-start="1802" data-ast-end="1850"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
            </Link>
          </div>

          {/* Supporting Text */}
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-medium">Werde Teil von medienschmiede.ai und transformiere Deine Medienproduktion schon heute mit KI-gestützter Präzision.</p>

        </div>
      </div>
    </section>;
}